var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{staticClass:"custom-control-danger",model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('strong',[_vm._v(" Ver únicamente la información que no pudo ser validada ")])])}
var staticRenderFns = []

export { render, staticRenderFns }